export default function IconButton({
  icon: Icon,
  label,
  variant = 'default',
  size = 'md',
  display = 'icon', // 'icon', 'label', 'both'
  onClick,
  disabled = false,
  className = '',
  ...props
}) {
  // Variant styles
  const variants = {
    default: 'bg-bg-secondary-light dark:bg-surface-dark hover:opacity-70 text-text-primary-light dark:text-text-primary',
    primary: 'bg-brand-primary hover:opacity-70 text-text-primary-light',
    secondary: 'bg-gray-100 dark:bg-surface-dark hover:opacity-70 text-text-primary-light dark:text-text-primary border border-border dark:border-border',
    danger: 'bg-red-600 hover:opacity-70 text-white',
    warning: 'bg-yellow-500 hover:opacity-70 text-text-primary-light',
    success: 'bg-green-600 hover:opacity-70 text-white',
    ghost: 'hover:opacity-70 text-text-primary-light dark:text-text-primary',
  };

  // Size styles
  const sizes = {
    xs: {
      button: 'p-0.5',
      icon: 'h-3 w-3',
      text: 'text-xs'
    },
    sm: {
      button: 'p-1',
      icon: 'h-4 w-4',
      text: 'text-sm'
    },
    md: {
      button: 'p-1',
      icon: 'h-5 w-5',
      text: 'text-base'
    },
    lg: {
      button: 'p-2.5',
      icon: 'h-6 w-6',
      text: 'text-lg'
    },
    xl: {
      button: 'p-3',
      icon: 'h-8 w-8',
      text: 'text-xl'
    }
  };

  const sizeClasses = sizes[size];
  const variantClasses = variants[variant];

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        ${display === 'icon' ? sizeClasses.button : 'px-3 py-2'}
        ${variantClasses}
        rounded-lg
        transition
        disabled:opacity-50
        disabled:cursor-not-allowed
        flex
        items-center
        gap-2
        ${className}
      `}
      title={display === 'icon' ? label : undefined}
      {...props}
    >
      {Icon && <Icon className={sizeClasses.icon} />}
      {(display === 'label' || display === 'both') && (
        <span className={sizeClasses.text}>{label}</span>
      )}
    </button>
  );
}
